// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".simple-page[data-v-583ef0b1]{display:flex;flex-direction:column;align-items:center;width:100%;gap:2rem;padding:2rem}", ""]);
// Exports
module.exports = exports;
